import React from 'react'
import { Link } from 'gatsby'
import styled from '@emotion/styled'

import Route from '~/constants/route'

import { Label } from '~/components/common'
import Layout from '~/components/Layout'

type Props = { description?: string }

const CustomError: React.VFC<Props> = ({
  description = '요청한 페이지 경로가 잘못 되었거나 존재하지 않습니다.',
}) => {
  return (
    <Layout title="404" noFooter>
      <Wrapper>
        <TextWrapper>
          <h1>
            <strong>404 </strong>NOT FOUND 🥲
          </h1>
          <p>{description}</p>

          <LinkWrapper>
            <Link to={Route.main}>
              <Label clickable>홈으로 가기</Label>
            </Link>
            <Link to={Route.post}>
              <Label clickable>게시글 목록 보기</Label>
            </Link>
          </LinkWrapper>

          {/* TODO: 최근 게시글 유도 */}
        </TextWrapper>
      </Wrapper>
    </Layout>
  )
}

const Wrapper = styled.section`
  width: 100%;

  display: flex;
  flex-direction: column;
  margin: auto;
`

const TextWrapper = styled.div`
  margin-bottom: 50px;
  text-align: center;

  @media ${({ theme: { device } }) => device.mobile} {
    margin-bottom: 30px;
  }

  h1 {
    margin-bottom: 30px;
    color: ${({ theme: { colors } }) => colors.deepText};

    strong {
      font-family: inherit;
      color: ${({ theme: { palette } }) => palette.purple};
    }

    @media ${({ theme: { device } }) => device.mobile} {
      margin-bottom: 20px;
    }
  }

  p {
    ${({ theme: { typography } }) => typography.body2}
    margin-bottom: 20px;
    color: ${({ theme: { colors } }) => colors.darkText};

    @media ${({ theme: { device } }) => device.mobile} {
      margin-bottom: 10px;
    }
  }
`

const LinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 5px;
  text-align: center;
`

export default CustomError
